// src/store/counterSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ITipTapTokenState {
  value: string;
}

const initialState: ITipTapTokenState = {
  value: '',
};

const tiptapTokenSlice = createSlice({
  name: 'tiptapToken',
  initialState,
  reducers: {
    setTokenValue: (state, action: PayloadAction<string>) => {
      state.value = action.payload;
    },
  },
});

export const { setTokenValue } = tiptapTokenSlice.actions;

export default tiptapTokenSlice;
